import { createReducer, on } from '@ngrx/store';
import { Presentation } from '../../../core/models/presentation.model';
import { PresentationsActions } from './presentations.actions';

export type PresentationsState = {
  readonly presentations: ReadonlyArray<Presentation>;
  readonly total: number;
  readonly page: number;
  readonly perPage: number;
  readonly isLoading: boolean;
  readonly error: string | null;
};

export const initialPresentationsState: PresentationsState = {
  presentations: [],
  total: 0,
  page: 1,
  perPage: 20,
  isLoading: false,
  error: null,
};

export const presentationsReducer = createReducer(
  initialPresentationsState,

  on(PresentationsActions.loadPresentations, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(PresentationsActions.loadPresentationsSuccess, (state, { response }) => ({
    ...state,
    presentations: response.presentations,
    total: response.total,
    page: response.page,
    perPage: response.perPage,
    isLoading: false,
  })),

  on(PresentationsActions.loadPresentationsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
);
